export default "__VITE_ASSET__ca33ae6a__"